import React from 'react'
import PropTypes from 'prop-types'
import MainMenu from './menu'
import Footer from '../components/footer'

import '../scss/app.scss'

const TemplateWrapper = ({ children }) => (
  <div className="site">
    <MainMenu />
    <div className="site-content">{children()}</div>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js